(function () {
    window.addEventListener('load', function () {

        var MobileMenu = {
            classes: {
                SECOND_LEVEL_LIST_ITEMS: '.mobile-menu ul.level-2 li',
                NAV: '.mobile-menu nav',
                MENU_STATE_INPUT_ID: 'mobileMenuState',
                MENU_SIDE_BACKGROUND: '.mobile-menu .mobile-menu-bg',
                MENU_ITEM: '.mobile-menu .menu-item',
                MENU_HEADERS: '.mobile-menu .menu-header',
                SERVICE_MENU: '.mobile-menu .service',
                HIDDEN_CLASS: 'visibility-is-hidden',
                ACTIVE_CLASS: 'is-active',
                LANGUAGE_MENU: '.mobile-language-menu',
                ANIMATION_SPEED: 700,
            },
            checkIfItsHeaderOrLink: function () {
                var secondLevelItems = document.querySelectorAll('.mobile-menu ul.level-2 li > *:not(ul)');

                if (secondLevelItems.length === 0) { return; }

                for (var i = 0; i < secondLevelItems.length; i++) {
                    var links = secondLevelItems[i].querySelectorAll('a');

                    if (links.length > 0) {
                        var menuItem = secondLevelItems[i].parentNode.querySelector('.menu-item');
                        if (menuItem) {
                            secondLevelItems[i].parentNode.removeChild(menuItem);
                        }  
                    }
                }
            },
            setFixedBody: function () {
                return; // Temporarily disable setting a fixed body
                var menu = document.getElementById(this.classes.MENU_STATE_INPUT_ID);

                if (menu.checked) {
                    document.body.style.position = "fixed";
                    document.body.style.setProperty('width', '100%', 'important');
                    document.querySelector(this.classes.MENU_SIDE_BACKGROUND).classList.remove(this.classes.HIDDEN_CLASS);
                } else {
                    document.body.style.position = "static";
                    document.body.style.setProperty('width', 'auto', 'important');
                    document.querySelector(this.classes.MENU_SIDE_BACKGROUND).classList.add(this.classes.HIDDEN_CLASS);
                }
            },
            openNextLevel: function (event) {
                var header = event.target;
                var subMenu = header.parentNode;
                var subMenuParent = subMenu.parentNode;

                // move current level folder items || links to left
                Array.prototype.forEach.call(subMenuParent.children, function (li) {
                    Array.prototype.forEach.call(li.children, function (listChildren) {
                        if (listChildren.matches('.menu-item') || listChildren.matches('.menu-leaf')) {
                            listChildren.style.left = '-100%';                        
                       }
                    }.bind(this));
                }.bind(this));

                this.showNextLeveLItems(subMenu);

                //hide service-menu
                document.querySelector(this.classes.SERVICE_MENU).style.left = '-100%'; 
            }, 
            showNextLeveLItems: function (subMenu) {
                //remove prev menu-header active class
                subMenu.parentNode.parentNode.querySelector(this.classes.MENU_HEADERS).classList.remove(this.classes.ACTIVE_CLASS);
                //li element add class active
                subMenu.classList.add('active');

                setTimeout(function () {
                    subMenu.querySelector('ul').style.right = '0%';
                    subMenu.querySelector(this.classes.MENU_HEADERS).style.right = '0%';
                    subMenu.querySelector(this.classes.MENU_HEADERS).classList.add(this.classes.ACTIVE_CLASS);
                  
                    Array.prototype.forEach.call(subMenu.querySelectorAll('ul > li'), function (element) {
                        var menuItem = element.querySelector('.menu-item') || element.querySelector('.menu-leaf');

                        if (menuItem) {
                            menuItem.style.left = '0%';
                        }
                    });
                }.bind(this), 0);
            },
            backPreviousLevel: function (event) {
                var header = event.target;
                var subMenu = header.parentNode; //li
                var subMenuParent = subMenu.parentNode; //ul

                Array.prototype.forEach.call(subMenu.querySelectorAll('ul, .menu-header'), function (element) {
                    element.style.right = '-100%';
                    setTimeout(function () {
                        element.classList.remove(this.classes.ACTIVE_CLASS);
                    }.bind(this), this.classes.ANIMATION_SPEED);                 
                }.bind(this));

                //if we have prev level and it has a heading 
                this.showPrevLevelItems(subMenuParent);

                //only move service menu back if it's first level as the  is relative
                if (!subMenu.parentNode.classList.contains('level-2')) {
                    document.querySelector(this.classes.SERVICE_MENU).style.left = '0%';                  
                }
            },
            showPrevLevelItems: function (subMenuParent) {
                var prevLevelHeader = subMenuParent.parentNode.querySelector(this.classes.MENU_HEADERS);
                var prevLevelList = subMenuParent.parentNode.querySelector('ul');

                if (prevLevelHeader.length > 0 && prevLevelList.length > 0) {
                    prevLevelHeader.style.left = '0%';
                    setTimeout(function () {
                        prevLevelHeader.style.left = '';
                        prevLevelHeader.style.right = '0%';
                        prevLevelHeader.classList.add(this.classes.ACTIVE_CLASS);
                    }.bind(this), this.classes.ANIMATION_SPEED);

                    prevLevelList.querySelector('li > .menu-item, li > .menu-leaf').style.left = '0%';
                  
                } else {
                    //show prev menu-items(folders/headings)
                    Array.prototype.forEach.call(subMenuParent.querySelectorAll('li .menu-item, li .menu-leaf'), function (element) {
                        element.style.left = '0%';
                    }.bind(this));
                }
            },
            changeLanguage: function (event) {                
                event.preventDefault();

                var url = event.target.value;
                window.location.href = url;
            },
            removeEmtpyLanguage: function () {
                if (this.classes.LANGUAGE_MENU.length === 0) {
                  document.querySelector(this.classes.NAV).querySelector('.language-wrapper').remove();
                }
            },
            closeMenuOnClickOutside: function (event) {
                var nav = document.querySelector(this.classes.NAV);
                var state = document.getElementById(this.classes.MENU_STATE_INPUT_ID);
                var toggleIcon = document.querySelector('.mobile-menu .nav-toggle');
                
                //if menu visible and clicked outside close it
                if (!toggleIcon.contains(event.target)) {
                    if (!event.target.contains(state) && !nav.contains(event.target)) {                      
                        document.getElementById(this.classes.MENU_STATE_INPUT_ID).checked = false;
                        this.setFixedBody();
                    }
                }
            },
            init: function () {
                var menuState = document.getElementById(this.classes.MENU_STATE_INPUT_ID);
                var menuItems = document.querySelectorAll(this.classes.MENU_ITEM);
                var menuHeaders = document.querySelectorAll(this.classes.MENU_HEADERS);
                var languageMenu = document.querySelectorAll(this.classes.LANGUAGE_MENU);

                if (menuItems.length === 0) {
                    return;
                }

                //make body not scrollable when menu is active
                if (menuState) {
                    menuState.addEventListener('change', function () {
                        this.setFixedBody();
                    }.bind(this));
                }
                
                //if it's a link remove menu-item as there are no next menus to show.
                this.checkIfItsHeaderOrLink();

                //Menu item for going to next menu
                Array.prototype.forEach.call(menuItems, function (element) {
                    element.addEventListener('click', function (event) {
                        this.openNextLevel(event);
                    }.bind(this));
                }.bind(this));

                //Menu Header's for going back to prev menu
                Array.prototype.forEach.call(menuHeaders, function (element) {
                    element.addEventListener('click', function (event) {
                        this.backPreviousLevel(event);
                    }.bind(this));  
                }.bind(this));

                //language selector
                Array.prototype.forEach.call(languageMenu, function (element) {
                    element.addEventListener('change', function (event) {
                        this.changeLanguage(event);
                    }.bind(this));
                }.bind(this));

                //remove empty language
                this.removeEmtpyLanguage();


                // close menu on click outside! (with a fix for iPhone to add some styling to the body that "allows" clicks on non-clickable elements (HTML or BODY tags)
                if (navigator.userAgent.match(/iP(hone|od|ad)/i)) {
                    document.querySelector('body').style.cursor = 'pointer';
                }
                document.querySelector('html').addEventListener('click', function (event) {
                    this.closeMenuOnClickOutside(event);
                }.bind(this));
            }
        };    

        MobileMenu.init();

    }, false);
})();